import Vue from "vue";

export const getMe = ({ commit }) => {
  return new Promise((resolve, reject) => {
    Vue.$axios
      .get("user/me")
      .then(call => {
        commit("SET_ME", call.data);
        resolve();
      })
      .catch(() => reject());
  });
};

export const matchUser = ({ rootState, commit }) => {
  return new Promise((resolve, reject) => {
    let url = `user/${rootState.application.matchable}/match?apiKey=${rootState.pageParams.apiKey}&productId=${rootState.pageParams.productId}&amount=${rootState.pageParams.desiredQuantity}`;
    // Check if there is multiple products in the object property
    if (
      rootState.pageParams.hasOwnProperty("products") &&
      rootState.pageParams.products.length > 0
    ) {
      // Loop through products
      let products = rootState.pageParams.products;
      // Multiple products will send SKU's instead of ID'S!!!!!!
      products.forEach(product => {
        url += `&productIds=${product._id}`;
      });
    }

    // Do Api call
    Vue.$axios
      .get(url)
      .then(call => {
        commit("SET_MATCH_ME", call.data);
        commit("pageParams/SET_MATCH_DATA", call.data, { root: true });
        resolve();
      })
      .catch(() => reject());
  });
};

export const requestPasswordReset = ({ commit }, email) => {
  return new Promise((resolve, reject) => {
    Vue.$axios
      .get("user/" + email + "/request_password_reset_v2")
      .then(call => {
        if (call.data && call.data["STATUS"] === "OK") {
          commit("SET_PASSWORD_RESET_EMAIL", email);
          resolve();
        } else {
          reject();
        }
      })
      .catch(() => reject());
  });
};

export const passwordReset = ({ rootState, commit }, password) => {
  return new Promise((resolve, reject) => {
    Vue.$axios
      .post("user/" + rootState.users.passwordReset.email + "/reset_password", {
        password: password,
        token: rootState.users.passwordReset.confirmationCode
      })
      .then(call => {
        commit("CLEAR_PASSWORD_RESET");
        if (call.data && call.data["STATUS"] === "OK") {
          resolve();
        } else {
          reject();
        }
      })
      .catch(() => reject());
  });
};
